import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import TeamMemberCard from "@/components/TeamMemberCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TeamPage = () => {
  const { t } = useTranslation();
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const response = await axios.get(`${API}/team`);
        setTeam(response.data);
      } catch (error) {
        console.error("Error fetching team:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTeam();
  }, []);

  return (
    <div className="min-h-screen pt-24 pb-20" data-testid="team-page">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <span className="text-primary font-medium tracking-widest uppercase text-sm">
            {t("team.subtitle")}
          </span>
          <h1 className="font-serif text-4xl md:text-6xl font-bold mt-2">
            {t("team.title")}
          </h1>
          <p className="text-muted-foreground mt-6 max-w-3xl mx-auto text-lg leading-relaxed">
            {t("team.intro")}
          </p>
        </div>

        {/* Hero Image */}
        <div className="relative h-80 md:h-[500px] rounded-3xl overflow-hidden mb-16">
          <img
            src="https://images.pexels.com/photos/30233748/pexels-photo-30233748.jpeg"
            alt="Team"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
            <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-2">
              {t("team.subtitle")}
            </h2>
            <p className="text-white/80 max-w-2xl">
              {t("footer.tagline")}
            </p>
          </div>
        </div>

        {/* Team Grid */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-96 bg-muted rounded-2xl animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {team.map((member) => (
              <TeamMemberCard key={member.id} member={member} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamPage;
